var History = function() {
    return {
        initReceivedRequestHandlers: function() {
            $('#received_history_friend_reject_btn').click(function() {
                Ajax.rejectHistoryFriend(
                    $(this).data('uid'), function() {
                        $('#received_history_friend_modal').modal('hide');
                    }
                );
            });
            $('#received_history_friend_accept_btn').click(function() {
                if (!Common.isLoggedin) {
                    $('#received_history_friend_modal').modal('hide');
                    if ($('#register_login_modal').length) {
                        // register/login modal is rendered
                        Common.showRegisterLoginModal('history', $(this).data('uid'));
                    } else {
                        // redirect to /history where user will complete the loop
                        top.location.href = '/history';
                    }
                    return;
                }
                Ajax.acceptHistoryFriend(
                    $(this).data('uid'), function() {
                        $('#received_history_friend_modal').modal('hide');
                        top.location.href = top.location.href;
                    }
                );
            });
        },
        init: function() {
            $('.ii__show_more_history').click(function() {
                $('.ii__hidden_' + $(this).data('uid')).show();
                $(this).hide();
            });
            $('.ii__add_history_friend').click(function() {
                if ($(this).data('action') == 'login') {
                    Common.showRegisterLoginModal('history', false);
                    return;
                }
                Modal.showModal(
                    'history_friend_modal',
                    {uid: $(this).data('uid')},
                    function() {
                        $('#history_friend_btn').prop('disabled', false);
                        $('#history_friend_btn').click(function() {
                            $('#history_friend_btn').prop('disabled', true);
                            var uid = $(this).data('uid');
                            Ajax.addHistoryFriend(
                                uid, $('#history_msg').val(),
                                function(res) {
                                    Modal.hideModal('history_friend_modal');
                                    var msg = '';
                                    if (res == undefined || res['status'] == undefined) {
                                        $('#history_friend_btn').prop('disabled', false);
                                        return;
                                    } else if (res.status == 'already') {
                                        msg = 'Έχεις ήδη στείλει αίτημα φιλίας';
                                    } else if (res.status == 'friends') {
                                        msg = 'Είστε ήδη φίλοι';
                                    } else if (res.status == 'ok') {
                                        msg = 'Το αίτημα φιλίας έχει αποσταλεί';
                                    }
                                    $('#history_response-' + uid).text(msg);
                                    $('#history_friend_show_btn_' + uid).hide();
                                }
                            );
                        });
                    }
                );
            });
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = History;
}
